import { colors } from '../../colors';
var location = {
  bgColor: colors.paleGrey,
  cardBgColor: colors.white,
  secondaryBgColor: colors.black,
  cardShadow: colors.pureBlack,
  addressAccent: colors.dirtyBlue
};
export default location;